import { render } from "./NewMagnet.vue?vue&type=template&id=3017f405&scoped=true&bindings={\"magnetID\":\"props\",\"magnettypeID\":\"props\",\"loading\":\"data\",\"errored\":\"data\",\"magnet\":\"data\",\"magnettype\":\"data\",\"sight\":\"data\",\"saveMagnet\":\"options\"}"
import script from "./NewMagnet.vue?vue&type=script&lang=js"
export * from "./NewMagnet.vue?vue&type=script&lang=js"

import "./NewMagnet.vue?vue&type=style&index=0&id=3017f405&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3017f405"

export default script